import { Button } from "design-system/atoms/Button"
import { Plus } from "lucide-react"
import { ComponentPropsWithoutRef, forwardRef } from "react"
import { useTranslation } from "react-i18next"

// forwardRef: the popover trigger anchors to this button
export const AddTagButton = forwardRef<HTMLButtonElement, ComponentPropsWithoutRef<typeof Button>>(
  (props, ref) => {
    const { t } = useTranslation()

    return (
      <Button ref={ref} type="button" variant="secondary" size="sm" {...props}>
        <Plus />
        <span>{t("customers.tags.add")}</span>
      </Button>
    )
  },
)

AddTagButton.displayName = "AddTagButton"
